import { Box, Chip, Flex, type MantineSize, Tooltip } from '@mantine/core';
import { HI_STATUS, HI_STATUS_ICON } from '../config/status';
import { getHIColourByStatus } from '../lib/status-color';
import { getHINameByValue } from '../lib/status-name';
import { InputProps } from '@/shared/ui/datagrid';
import { useTranslation } from 'react-i18next';

export const HIStatusSelector = ({
  'data-testid': dataTestId,
  ...props
}: InputProps<string, string>) => {
  const { t } = useTranslation();
  return (
    <Chip.Group multiple {...props}>
      <Flex
        justify='center'
        gap={'xs'}
        wrap={'nowrap'}
        align={'center'}
        data-testid={dataTestId}
      >
        {[
          HI_STATUS.NO_DATA,
          HI_STATUS.OK,
          HI_STATUS.WARNING,
          HI_STATUS.ERROR,
          HI_STATUS.CRITICAL_ERROR,
        ].map((x) => {
          const Icon = HI_STATUS_ICON[x];
          return (
            <Tooltip label={t(getHINameByValue(x))} key={x.toString()}>
              <Box>
                <Chip
                  // radius={'xs'}
                  classNames={{
                    iconWrapper: '!hidden',
                    label:
                      '!py-0 !px-[4px] [&>span:last-child]:!flex [&>span:last-child]:!flex-col',
                  }}
                  attributes={{
                    input: {
                      'data-testid': `hi-status-selector-v-${x}`,
                    },
                  }}
                  size={36 as unknown as MantineSize}
                  value={x.toString()}
                  color={getHIColourByStatus(x)}
                  autoContrast
                >
                  <Icon />
                </Chip>
              </Box>
            </Tooltip>
          );
        })}
      </Flex>
    </Chip.Group>
  );
};